<template>
  <div>
    <v-row justify="center">
      <v-col cols="8">
        <v-card class="align-center">

          <v-card-title class="justify-center" style="background-color: #e6e6e6;">
            <v-icon left>mdi-cogs</v-icon>
            Proficiência da Turma
          </v-card-title>

          <v-card-text>

            <v-row dense class="justify-center">
              <v-icon left>mdi-filter</v-icon>
              <p style="margin-top: 15px; font-size: 20px;" class="font-weight-black">Selecione os
                dados</p>
            </v-row>

            <v-divider/>

            <br/>

            <v-row justify="center">
              <v-col cols="9">
                <v-select
                    :disabled="carregandoGrafico"
                    :items="cidades"
                    item-text="nome"
                    v-model="cidadeSelecionada"
                    no-data-text="Nenhuma cidade encontrada"
                    label="Cidade"
                    solo
                />
              </v-col>
            </v-row>

            <v-row justify="center" style="margin-top: -20px;">
              <v-col cols="9">
                <v-select
                    :disabled="carregando || carregandoGrafico"
                    :items="avaliacoes"
                    item-text="descricao"
                    v-model="avaliacaoSelecionada"
                    no-data-text="Nenhuma avaliação encontrada"
                    label="Avaliações"
                    @change="onAvaliacaoChange()"
                    return-object
                    solo
                />
              </v-col>
            </v-row>

            <v-row justify="center" style="margin-top: -20px;">
              <v-col cols="9">
                <v-select
                    :disabled="carregando || carregandoGrafico"
                    :items="escolas"
                    item-text="nome"
                    v-model="escolaSelecionada"
                    no-data-text="Nenhuma escola encontrada"
                    @change="onEscolaChange()"
                    return-object
                    label="Escola"
                    solo
                />
              </v-col>
            </v-row>

            <v-row justify="center" style="margin-top: -20px;">
              <v-col cols="9">
                <v-select
                    :disabled="carregando || carregandoGrafico"
                    :items="turmas"
                    item-text="turma"
                    v-model="turmaSelecionada"
                    no-data-text="Nenhuma turma encontrada"
                    return-object
                    label="Turma"
                    solo
                />
              </v-col>
            </v-row>

            <v-row class="justify-center" style="margin-top: -25px;">
              <v-btn color="primary" :disabled="turmaSelecionada == null"
                     :loading="carregandoGrafico" @click="confirmar()">GERAR RELATÓRIO</v-btn>
            </v-row>

          </v-card-text>

        </v-card>
      </v-col>
    </v-row>


  </div>
</template>

<script>
import RelatorioService from "@/service/RelatorioService";
import _ from "lodash";

export default {
  data() {
    return {

      carregando: false,

      cidades: [],
      cidadeSelecionada: {},

      avaliacoes: [],
      avaliacaoSelecionada: {},

      escolas: [],
      escolaSelecionada: {},

      turmas: [],
      turmaSelecionada: null,

      carregandoGrafico: false,
    }
  },
  methods: {
    graficos() {
      this.$router.push('/graficos')
    },

    findOwners() {
      this.carregando = true;
      RelatorioService.findOwners()
          .then(({data}) => {
            this.cidades = data;
            this.cidadeSelecionada = this.cidades[0];
            this.onOwnerChange();
          })
          .finally(() => {
            this.carregando = false;
          })
    },

    onOwnerChange() {
      this.carregando = true;
      RelatorioService.findAvaliacoes(this.cidadeSelecionada.id)
          .then( ({data}) => {
            this.avaliacoes = data;
          })
          .finally(() => {
            this.carregando = false;
          })
    },

    onAvaliacaoChange() {
      this.carregando = true;
      RelatorioService.findEscolasByAvaliacao(this.avaliacaoSelecionada.id)
          .then( ({data}) => {
            this.escolas = data;
          })
          .finally(() => {
            this.carregando = false;
          })
    },

    onEscolaChange() {
      RelatorioService.findTurmasByEscola(this.escolaSelecionada.id, this.avaliacaoSelecionada.id)
          .then( ({data}) => {
            this.allData = data;

            this.turmas = _.map(this.allData, function (t) {
              return {
                id: t.idturma,
                turma: t.turma
              }
            });
            this.turmas = _.uniqBy(this.turmas, 'id');
          })
          .finally(() => {
            this.carregando = false;
          })
    },

    confirmar() {

      this.carregandoGrafico = true;
      let filter = {
        cidadeId: this.cidadeSelecionada.id,
        avaliacaoId: this.avaliacaoSelecionada.id,
        turmaId: this.turmaSelecionada.id,
        type: "Turma"
      }

      let routeData = this.$router.resolve({name: 'MainRelatorio', query: filter});
      window.open("/relatorio"+routeData.href.replace('/', ''), '_blank');
      this.carregandoGrafico = false;

    }
  },



  created() {
    this.findOwners()
  }

}
</script>

<style>

</style>
